"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Toggler", {
    enumerable: true,
    get: function() {
        return Toggler;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../contexts/Theme");
const _ri = require("react-icons/ri");
const _AdminButton = require("../Button/AdminButton");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const Toggler = (param)=>{
    let { heading, subheading, headingSuffix, children, className, onToggle, defaultOpen = false, disabled = false, chevronButtonPosition = "left", ...props } = param;
    const [open, setOpen] = (0, _react.useState)(defaultOpen);
    const theme = (0, _Theme.useTheme)();
    const toggleIt = (0, _react.useCallback)(()=>{
        const o = !open;
        setOpen(o);
        if (onToggle != null) {
            onToggle(o);
        }
    }, [
        onToggle,
        open
    ]);
    const headerChevronButton = /*#__PURE__*/ _react.default.createElement(_AdminButton.AdminButton, {
        variant: "ghost",
        shape: "round",
        size: "md",
        onClick: toggleIt,
        className: "".concat(chevronButtonPosition === "left" ? "mr-3" : "ml-3", " toggler-").concat(open ? "close" : "open"),
        disabled: disabled
    }, open ? /*#__PURE__*/ _react.default.createElement(_ri.RiArrowUpSLine, {
        size: "23px",
        className: "arrow",
        color: theme.colors.medium
    }) : /*#__PURE__*/ _react.default.createElement(_ri.RiArrowDownSLine, {
        size: "23px",
        className: "arrow",
        color: theme.colors.medium
    }));
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        ...props,
        className: _style.default.dynamic([
            [
                "c71cbe4df98539ea",
                [
                    theme.colors.border,
                    theme.spacers.s4,
                    subheading != null ? "start" : "center",
                    chevronButtonPosition === "left" ? "flex-start" : "space-between",
                    open ? "777px" : "0",
                    open ? theme.spacers.s3 : theme.spacers.s0,
                    theme.animationDuration
                ]
            ]
        ]) + " " + "toggler ".concat(open ? "open" : "", " ").concat(className !== null && className !== void 0 ? className : "")
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "c71cbe4df98539ea",
                [
                    theme.colors.border,
                    theme.spacers.s4,
                    subheading != null ? "start" : "center",
                    chevronButtonPosition === "left" ? "flex-start" : "space-between",
                    open ? "777px" : "0",
                    open ? theme.spacers.s3 : theme.spacers.s0,
                    theme.animationDuration
                ]
            ]
        ]) + " " + "head"
    }, chevronButtonPosition === "left" && headerChevronButton, /*#__PURE__*/ _react.default.createElement("div", {
        onClick: toggleIt,
        className: _style.default.dynamic([
            [
                "c71cbe4df98539ea",
                [
                    theme.colors.border,
                    theme.spacers.s4,
                    subheading != null ? "start" : "center",
                    chevronButtonPosition === "left" ? "flex-start" : "space-between",
                    open ? "777px" : "0",
                    open ? theme.spacers.s3 : theme.spacers.s0,
                    theme.animationDuration
                ]
            ]
        ]) + " " + "cursor-pointer"
    }, /*#__PURE__*/ _react.default.createElement("h5", {
        className: _style.default.dynamic([
            [
                "c71cbe4df98539ea",
                [
                    theme.colors.border,
                    theme.spacers.s4,
                    subheading != null ? "start" : "center",
                    chevronButtonPosition === "left" ? "flex-start" : "space-between",
                    open ? "777px" : "0",
                    open ? theme.spacers.s3 : theme.spacers.s0,
                    theme.animationDuration
                ]
            ]
        ]) + " " + "m-0"
    }, heading), /*#__PURE__*/ _react.default.createElement("small", {
        className: _style.default.dynamic([
            [
                "c71cbe4df98539ea",
                [
                    theme.colors.border,
                    theme.spacers.s4,
                    subheading != null ? "start" : "center",
                    chevronButtonPosition === "left" ? "flex-start" : "space-between",
                    open ? "777px" : "0",
                    open ? theme.spacers.s3 : theme.spacers.s0,
                    theme.animationDuration
                ]
            ]
        ])
    }, subheading)), headingSuffix, chevronButtonPosition === "right" && headerChevronButton), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "c71cbe4df98539ea",
                [
                    theme.colors.border,
                    theme.spacers.s4,
                    subheading != null ? "start" : "center",
                    chevronButtonPosition === "left" ? "flex-start" : "space-between",
                    open ? "777px" : "0",
                    open ? theme.spacers.s3 : theme.spacers.s0,
                    theme.animationDuration
                ]
            ]
        ]) + " " + "body"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "c71cbe4df98539ea",
                [
                    theme.colors.border,
                    theme.spacers.s4,
                    subheading != null ? "start" : "center",
                    chevronButtonPosition === "left" ? "flex-start" : "space-between",
                    open ? "777px" : "0",
                    open ? theme.spacers.s3 : theme.spacers.s0,
                    theme.animationDuration
                ]
            ]
        ]) + " " + "content"
    }, children))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "c71cbe4df98539ea",
        dynamic: [
            theme.colors.border,
            theme.spacers.s4,
            subheading != null ? "start" : "center",
            chevronButtonPosition === "left" ? "flex-start" : "space-between",
            open ? "777px" : "0",
            open ? theme.spacers.s3 : theme.spacers.s0,
            theme.animationDuration
        ]
    }, ".toggler.__jsx-style-dynamic-selector{border:1px solid ".concat(theme.colors.border, ";-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;padding:").concat(theme.spacers.s4, "}h5.__jsx-style-dynamic-selector{font-weight:700}h5.__jsx-style-dynamic-selector{font-size:14px}.head.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:").concat(subheading != null ? "start" : "center", ";-webkit-align-items:").concat(subheading != null ? "start" : "center", ";-moz-box-align:").concat(subheading != null ? "start" : "center", ";-ms-flex-align:").concat(subheading != null ? "start" : "center", ";align-items:").concat(subheading != null ? "start" : "center", ";-webkit-box-pack:").concat(chevronButtonPosition === "left" ? "flex-start" : "space-between", ";-webkit-justify-content:").concat(chevronButtonPosition === "left" ? "flex-start" : "space-between", ";-moz-box-pack:").concat(chevronButtonPosition === "left" ? "flex-start" : "space-between", ";-ms-flex-pack:").concat(chevronButtonPosition === "left" ? "flex-start" : "space-between", ";justify-content:").concat(chevronButtonPosition === "left" ? "flex-start" : "space-between", "}.body.__jsx-style-dynamic-selector{overflow:hidden}.content.__jsx-style-dynamic-selector{max-height:").concat(open ? "777px" : "0", ";padding-top:").concat(open ? theme.spacers.s3 : theme.spacers.s0, ";-webkit-transition:all ").concat(theme.animationDuration, " ease-in-out!important;-moz-transition:all ").concat(theme.animationDuration, " ease-in-out!important;-o-transition:all ").concat(theme.animationDuration, " ease-in-out!important;transition:all ").concat(theme.animationDuration, " ease-in-out!important;overflow-y:scroll}")));
};

//# sourceMappingURL=Toggler.js.map